






// Import vendors ----------------------------------------------------------------------------------
import { defineComponent } from '@vue/composition-api';
import { useService } from '@xstate/vue';
// Import plugins ----------------------------------------------------------------------------------
import { usePodocore } from '@/plugins/podocore';
// Import components -------------------------------------------------------------------------------
import AuthSignUp from '@/components/auth/signUp/AuthSignUp.vue';
// -------------------------------------------------------------------------------------------------
export default defineComponent({
  name: 'PageAuthSignUp',
  components: { AuthSignUp },
  setup() {
    const authService = useService(usePodocore().getModuleService('auth'));

    return {
      authService
    };
  }
});
